// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"d84fa787","618":"a193cb4c"}[chunkId] + ".chunk.js";
};